import { render, staticRenderFns } from "./ClientActions.vue?vue&type=template&id=364cc3fe&"
import script from "./ClientActions.vue?vue&type=script&lang=js&"
export * from "./ClientActions.vue?vue&type=script&lang=js&"
import style0 from "./ClientActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports